import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isShareOpen: false,
  linkGuid: null,
};

const shareSlice = createSlice({
  name: 'share',
  initialState,
  reducers: {
    openShare: (state, action) => {
      state.isShareOpen = true;
      state.linkGuid = action.payload?.linkGuid || null;
    },
    closeShare: (state) => {
      state.isShareOpen = false;
      state.linkGuid = null;
    },
    toggleShare: (state) => {
      state.isShareOpen = !state.isShareOpen;
    },
  },
});

export const { openShare, closeShare, toggleShare } = shareSlice.actions;
export default shareSlice.reducer;
